import api from './client'
import { postParams } from '../lib/useParams'

export const getContracts = async (prm) => {
  // return api.get('contract/list', { params: { P_REQUEST: getParams(prm) } })
  return api.post('contract/list', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getContractDetail = async (prm) => {
  // return api.get('contract/getContractDetail', { params: { P_REQUEST: getParams(prm) } })
  return api.post('contract/getContractDetail', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const addContractToUser = async (prm) => {
  return api.post('contract/addToUser', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}

export const getMaterialInContracts = async (prm) => {
  // return api.get('contract/materialInContracts', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/materialInContracts', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getContractIncreaseReq = async (prm) => {
  // return api.get('contract/getContractIncReq', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getContractIncReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getContractRuleList = async (prm) => {
  // return api.get('contract/getContractRules', {
  //   params: {
  //     P_REQUEST: getParams({ rule_type: 'ADD_ORDER' })
  //   }
  // })
  return api.post('contract/getContractRules', postParams({ rule_type: 'ADD_ORDER' }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const addContractRuleForOrder = async (prm) => {
  return api.post('contract/addContractRule', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}

export const getUserCustomerIncReq = async (prm) => {
  // return api.get('contract/getUserCustomerIncReq', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getUserCustomerIncReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const addContractIncreaseRequest = async (prm) => {
  return api.post('contract/addContractIncreaseReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateContractIncreaseRequest = async (prm) => {
  return api.post('contract/updateContractIncreaseReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const addEfficiencyLossRate = async (prm) => {
  return api.post('contract/addEfficiencyLossRate', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const checkContractRequest = async (prm) => {
  return api.post('contract/checkContractIncreaseRequest', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}

export const getNewProductReqList = async (prm) => {
  // return api.get('contract/getNewProductReqList', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getNewProductReqList', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const getNewProductReq = async (prm) => {
  // return api.get('contract/getNewProductReq', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getNewProductReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const addNewProductReq = async (prm) => {
  return api.post('contract/addNewProductReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateNewProductReq = async (prm) => {
  return api.post('contract/updateNewProductReqWorkflowStatus', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const addNewProductReqItem = async (prm) => {
  return api.post('contract/addNewProductReqItem', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateNewProductHeaderRow = async (prm) => {
  return api.post('contract/updateNewProductHeaderRows', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateContractCloseReq = async (prm) => {
  return api.post('contract/updateContractCloseReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const getContractLimitInfo = async (prm) => {
  // return api.get('contract/getContractLimitInfo', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getContractLimitInfo', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const addLimitReq = async (prm) => {
  return api.post('contract/addLimitReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}

export const getContractLimitList = async (prm) => {
  // return api.get('contract/getContractLimit', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getContractLimit', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const getContractLimitDetail = async (prm) => {
  // return api.get('contract/getLimitReqDetail', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getLimitReqDetail', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const getLimitReqDetailPrintData = async (prm) => {
  // return api.get('contract/getLimitReqDetailPrintData', {
  //   params: {
  //     P_REQUEST: getParams({ id_contract_limit_req: prm })
  //   }
  // })
  return api.post('contract/getLimitReqDetailPrintData', postParams({ id_contract_limit_req: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const addLimitReqDetail = async (prm) => {
  return api.post('contract/addLimitReqDetail', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}

export const updateLimitReqDetails = async (prm) => {
  return api.post('contract/updateLimitReqDetails', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateLimitReqFile = async (prm) => {
  return api.post('contract/updateLimitReqFile', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const calculateLimitReq = async (prm) => {
  return api.post('contract/calculateLimitReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const getLimitReqLogs = async (prm) => {
  // return api.get('contract/getLimitReqLogs', {
  //   params: {
  //     P_REQUEST: getParams(prm)
  //   }
  // })
  return api.post('contract/getLimitReqLogs', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const calculateLimitDecrease = async (prm) => {
  return api.post('contract/getLimitDecreaseCalc', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
// export const reCalculateLimitDecrase = async (prm) => {
//   return api.post('contract/calculateLimitDecrase', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
//     return result.data
//   })
// }
export const saveLimitRequest = async (prm) => {
  return api.post('contract/saveLimitIncrease', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateLimitReq = async (prm) => {
  return api.post('contract/updateLimitReq', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const getLimitContractMaterials = async (prm) => {
  // return api.get('contract/getLimitContractMaterials', { params: { P_REQUEST: getParams(prm) } })
  return api.post('contract/getLimitContractMaterials', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
// export const updateLimitReqDiscounted = async (prm) => {
//   return api.post('contract/updateLimitReqDiscounted', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
//     return result.data
//   })
// }
export const addLimitReqBlock = async (prm) => {
  return api.post('contract/addLimitReqBlock', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateContractLimitMaterials = async (prm) => {
  return api.post('contract/updateContractLimitMaterials', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const clearLimitReqDetails = async (prm) => {
  return api.post('contract/clearLimitReqDetails', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const updateLimitContractTotal = async (prm) => {
  return api.post('contract/updateLimitContractTotal', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const getLimitWorkflowHistory = async (prm) => {
  // return api.get('contract/getLimitWorkflowHistory', { params: { P_REQUEST: getParams(prm) } })
  return api.post('contract/getLimitWorkflowHistory', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const updateLimitLineReject = async (prm) => {
  return api.post('contract/updateLimitLineReject', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
export const getContractDuplicateRows = async () => {
  return api.post('contract/getContractDuplicateRows', postParams(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}